import React, { useState } from "react";
import { motion } from "framer-motion";
import mLogo from '../../Assets/Images/logo.jpeg'
import logo from "../../Assets/Images/logo.png";
import { useHistory } from "react-router-dom";
import { IoLanguage } from "react-icons/io5";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { setLanguage } from "../../Store/Theme/actions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const TopBar = () => {
  const history = useHistory();
  const [openLangMenu, setOpenLangMenu] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const lang = useSelector((state) => state.theme.language);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const navItems = [
    { name: t("Home"), path: "/" },
    { name: t("About Us"), path: "/aboutUs" },
    { name: t("Contact Us"), path: "/contactUs" },
    { name: t("Success Stories"), path: "/successStories" },
    { name: t("Pricing"), path: "/pricing" },
    { name: t("Login/Signup"), path: "/auth/login" },
  ];

  return (
    <div className="bg-white shadow-md h-20 w-full flex items-center justify-between md:px-4 md:px-8">
      {/* Logo */}
     <div className="bg-primeColor flex flex-row w-72 py-2  h-full cursor-pointer" onClick={() => history.push('/')}>
        <img src={mLogo} height={50} width={50} className="mx-2"/>
                <img src={logo} height={100} width={200} alt="logo" />
            </div>

      {/* Desktop Navigation */}
      <div className="hidden lg:flex flex-row gap-8 items-center">
        {navItems.map((item) => (
          <div
            key={item.path}
            className={`text-black text-base xl:text-lg cursor-pointer hover:underline underline-offset-4 hover:font-bold hover:text-primeColor ${
              history.location.pathname === item.path
                ? "underline font-bold text-primeColor"
                : "font-medium"
            }`}
            onClick={() => history.push(item.path)}
          >
            {item.name}
          </div>
        ))}

        {/* Language Selector */}
        <div className="relative">
          <div
            className="flex items-center justify-center p-2 hover:bg-primeColor hover:text-white cursor-pointer rounded-full"
            onClick={() => setOpenLangMenu(!openLangMenu)}
          >
            <IoLanguage size={22} />
          </div>
          <span className="absolute -top-2 -right-3 w-6 h-6 bg-white text-sm rounded-full shadow flex items-center justify-center">
            {lang || "en"}
          </span>

          {openLangMenu && (
            <div className="absolute top-full right-0 mt-2 w-32 bg-white shadow-lg rounded-md py-2 z-50">
              <p
                className="text-sm text-gray-700 py-2 px-2 cursor-pointer hover:bg-primeColor hover:text-white"
                onClick={() => {
                  dispatch(setLanguage("en"));
                  setOpenLangMenu(false);
                }}
              >
                English
              </p>
              <p
                className="text-sm text-gray-700 py-2 px-2 cursor-pointer hover:bg-primeColor hover:text-white"
                onClick={() => {
                  dispatch(setLanguage("ta"));
                  setOpenLangMenu(false);
                }}
              >
                Tamil
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu Toggle Button */}
      <div className="lg:hidden px-2 flex items-center">
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="text-2xl"
        >
          {mobileMenuOpen ? <HiX /> : <HiMenuAlt3 />}
        </button>
      </div>

      {/* Mobile Menu Drawer */}
      {mobileMenuOpen && (
        <div className="absolute top-20 left-0 w-full bg-white shadow-lg z-50 flex flex-col gap-4 py-4 px-6 lg:hidden">
          {navItems.map((item) => (
            <div
              key={item.path}
              className={`text-black text-base cursor-pointer hover:font-semibold hover:text-primeColor ${
                history.location.pathname === item.path
                  ? "font-bold text-primeColor"
                  : ""
              }`}
              onClick={() => {
                history.push(item.path);
                setMobileMenuOpen(false);
              }}
            >
              {item.name}
            </div>
          ))}

          {/* Language Toggle in Mobile */}
          <div className="flex items-center justify-between mt-2">
            <span className="text-gray-700">Language:</span>
            <div className="flex gap-2">
              <button
                className={`text-sm px-2 py-1 rounded ${
                  lang === "en"
                    ? "bg-primeColor text-white"
                    : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => {
                  dispatch(setLanguage("en"));
                  setMobileMenuOpen(false);
                }}
              >
                EN
              </button>
              <button
                className={`text-sm px-2 py-1 rounded ${
                  lang === "ta"
                    ? "bg-primeColor text-white"
                    : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => {
                  dispatch(setLanguage("ta"));
                  setMobileMenuOpen(false);
                }}
              >
                TA
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopBar;